/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_ModeInputs */

const en_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Mode`)
};

const es_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de lectura`)
};

const fr_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode lecture`)
};

const de_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesemodus`)
};

const ja_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リーディングモード`)
};

const zh_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读模式`)
};

const ar_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضع القراءة`)
};

const id_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode Baca`)
};

const it_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità Lettura`)
};

const ru_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим чтения`)
};

const pt_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de Leitura`)
};

const ko_reading_mode = /** @type {(inputs: Reading_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`읽기 모드`)
};

/**
* | output |
* | --- |
* | "Reading Mode" |
*
* @param {Reading_ModeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reading_mode = /** @type {((inputs?: Reading_ModeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_ModeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reading_mode(inputs)
	if (locale === "es") return es_reading_mode(inputs)
	if (locale === "fr") return fr_reading_mode(inputs)
	if (locale === "de") return de_reading_mode(inputs)
	if (locale === "ja") return ja_reading_mode(inputs)
	if (locale === "zh") return zh_reading_mode(inputs)
	if (locale === "ar") return ar_reading_mode(inputs)
	if (locale === "id") return id_reading_mode(inputs)
	if (locale === "it") return it_reading_mode(inputs)
	if (locale === "ru") return ru_reading_mode(inputs)
	if (locale === "pt") return pt_reading_mode(inputs)
	return ko_reading_mode(inputs)
});